// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__21ZSi","title":"Images90_title__1E5nN","images":"Images90_images__2bpdP"};